import React, { createContext, useState } from "react";

const DataContext = createContext(null);

const baseUrl = process.env.REACT_APP_API_URL;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ContextProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    payeeName: "",
    payeeEmail: "",
    recipient_name: "",
    country: {},
    phone: "",
    birthdate: "",
    tone: "Motivational",
  });

  const [countryCodes, setCountryCodes] = useState([]);

  const [modalVisibility, setModalVisibility] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [loading, setLoading] = useState(false);

  const [otherFormPart, setOtherFormPart] = useState(false);

  const [formVisibility, setFormVisibility] = useState(false);

  const [subscriptionPrice, setSubscriptionPrice] = useState("05.00");

  const getCountryCodes = async () => {
    try {
      const countryCodeResponse = await fetch(
        "https://restcountries.com/v3.1/all"
      );
      const result = await countryCodeResponse.json();

      const formattedData = result
        .map((country) => ({
          name: country.name.common,
          code:
            country.idd?.root +
            (country.idd?.suffixes ? country.idd.suffixes[0] : ""),
        }))
        .filter((country) => country.code);

      setCountryCodes(formattedData);
    } catch (error) {
      console.error("Error fetching country codes:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCountryChange = (selected) => {
    setFormData({ ...formData, country: selected });
  };

  const toggleFormVisibility = () => {
    setFormVisibility((prevValue) => !prevValue);
  };

  const handleFormStep = () => {
    const isValidEmail = (email) => emailRegex.test(email);

    if (
      formData.payeeName === "" ||
      formData.payeeEmail === "" ||
      !isValidEmail(formData.payeeEmail)
    ) {
      alert("Invalid input: Please check the name and email.");
      return;
    }

    setOtherFormPart((prevValue) => !prevValue);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      // Ensure terms are accepted
      if (acceptedTerms !== true) {
        setModalVisibility(true);
        return;
      }

      // Phone number validation using regex
      // const hasCountryCode = /^\+\d{1,4}/.test(formData.phone);

      // if (!hasCountryCode) {
      //   alert(
      //     "Please enter a valid phone number with a country code (e.g., +2348123456789)"
      //   );
      //   return;
      // }

      // Save member data
      localStorage.setItem("memberData", JSON.stringify(formData));

      setLoading((prevValue) => !prevValue);

      // Send request
      const response = await fetch(`${baseUrl}subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          subscriptionName:
            subscriptionPrice === "05.00" ? "oneMessage" : "moreMessages",
          subscriptionPrice,
        }),
      });

      const result = await response.json();

      // // Save session ID
      // localStorage.setItem('deposit', result.sessionID);

      // Redirect to payment
      window.location = result.url;
    } catch (error) {}
  };

  const handleModalVisibility = () => {
    setModalVisibility((prevValue) => !prevValue);
    setAcceptedTerms((prevValue) => !prevValue);
  };

  const handleSubChange = (e) => {
    const { value } = e.target;

    if (value === "oneMessage") {
      setSubscriptionPrice("05.00");
    } else {
      setSubscriptionPrice("12.00");
    }
  };

  const saveMemberToDb = async () => {
    try {
      const storedData = localStorage.getItem("memberData");

      if (!storedData) {
        throw new Error("No member data found in localStorage.");
      }

      let memberData;

      try {
        memberData = JSON.parse(storedData);
      } catch (parseError) {
        throw new Error("Failed to parse memberData from localStorage.");
      }

      if (typeof memberData !== "object" || memberData === null) {
        throw new Error("Invalid memberData format.");
      }

      const response = await fetch(`${baseUrl}save-member`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(memberData),
      });

      if (!response.ok) {
        throw new Error(
          `An error occurred: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();

      localStorage.removeItem("memberData");

      return result;
    } catch (error) {
      console.error("Error saving member to DB:", error);
    }
  };

  return (
    <DataContext.Provider
      value={{
        setFormData,
        formData,
        handleChange,
        handleSubmit,
        handleSubChange,
        subscriptionPrice,
        saveMemberToDb,
        toggleFormVisibility,
        formVisibility,
        otherFormPart,
        setOtherFormPart,
        handleFormStep,
        handleModalVisibility,
        modalVisibility,
        countryCodes,
        getCountryCodes,
        loading,
        handleCountryChange,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
